<template>
  <div class="custom_pagination">
    <div class="col-12 override-padding">
      <div class="col-lg-10 col-md-8 override-padding float-left">
        <div class="pagination-width float-left override-padding">
          <b-pagination
           v-model="currentPageValue"
           :total-rows="totalRows"
           :per-page="perPage"
           first-text="<<"
           prev-text="<"
           next-text=">"
           last-text=">>"
           :hide-goto-end-buttons=false
           @input="showPaginatedFunction"
           ></b-pagination>
        </div>
        <div class="goto-width float-left override-padding">
          <div class="col-12 override-padding">
            <span class="col-lg-6 col-md-6 float-left override-padding" style="padding-top: 6px;">
              Go to page:
            </span>
            <span class="col-lg-4 col-md-6 float-left override-padding">
              <b-form-select
                  class="col-md-10 input-height-30 padding-lr-5 margin-bottom-5"
                  v-model="currentPageValue"
                  :options="pageOptions"
                  @change="showPaginatedFunction"
                  >
                  </b-form-select>
            </span>
          </div>
        </div>
        <div class="goto-width float-left override-padding">
          <div class="col-12">
            <span class="col-lg-7 col-md-6 float-left override-padding" style="padding-top: 6px;">
              Row count:
            </span>
            <span class="col-lg-4 col-md-6 float-left override-padding">
              <b-form-select
                  class="col-md-12 input-height-30 padding-lr-5 margin-bottom-5"
                  v-model="perPageValue"
                  :options="perPageOptions"
                  @change="showPerPageFunction"
                  >
                  </b-form-select>
            </span>
          </div>
        </div>
      </div>
      <div class="col-lg-2 col-md-4 override-padding float-right text-align-right" style="padding-top: 6px;">
        Showing {{ sNo + 1 }}-{{ getPageLastNo() }} of {{ totalRows }}
      </div>
     </div>
  </div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import axios from 'axios';

export default {
    props: {
        currentPage: Number,
        totalRows: Number,
        perPage: Number,
        showPaginatedFunction: Function,
        showPerPageFunction: Function,
        totalPages: Number,
        sNo: Number,
    },
    data() {
      return {
        currentPageValue: this.currentPage,
        pageOptions: [],
        perPageOptions: [
          { value: 50, text: '50' },
          { value: 100, text: '100' },
          { value: 150, text: '150' },
          { value: 200, text: '200' },
        ],
        perPageValue: this.perPage,
        totalPagesValue: this.totalPages,
      }
    },
    methods: {
      getPageOptions: function() {
        this.pageOptions = [];
        for(var i=1; i<=this.totalPagesValue; i++) {
          this.pageOptions.push({
            value: i, text: i,
          });
        }
        return this.pageOptions;
      },
      getPageLastNo: function() {
        var getPageLastSno = '';
        getPageLastSno = parseInt(this.sNo) + parseInt(this.perPage);
        if(getPageLastSno > this.totalRows) {
          return this.totalRows;
        }
        else {
          return getPageLastSno;
        }
      },
    },
    created: function() {
      this.getPageOptions();
    }

}
</script>

<style>
  .custom_pagination .page-link {
    padding: 7px;
    color: #000;
  }
  .custom_pagination .page-item.active .page-link {
    /* background-color: #dc2227;
    border: 1px solid #dc2227; */
    background-color: #00ACEE;
    border: 1px solid #00ACEE;
  }
  .pagination-width {
    width: 300px;
  }
  .goto-width {
    width: 200px;
  }
</style>



// WEBPACK FOOTER //
// src/components/pagination.vue